import { AgGridCellEditComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-edit.component';
import { AgGridCellOrderNumComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-order-num.component';
import { AgGridCellPlantComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-plant.component';
import { AgGridCellSymbolComponent } from '@app/ui/ag-grid-cell-renderer/ag-grid-cell-symbol.component';
import { AgGridNumericEditorComponent } from '@app/ui/ag-grid-cell-editor/ag-grid-numeric-editor.component';
import { AutocompleteChiplistComponent } from '@app/ui/autocomplete-chiplist/autocomplete-chiplist.component';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ExpandablePanelComponent } from '@app/ui/expandable-panel/expandable-panel.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormLinkComponent } from '@app/ui/form-link/form-link.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatOptionModule
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  MAT_MOMENT_DATE_FORMATS,
  MatMomentDateModule,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { MatChipsModule } from '@angular/material/chips';
import { NgModule } from '@angular/core';
import { OptionMultiSelectComponent } from '@app/ui/option-multi-select/option-multi-select.component';
import { SearchToggleComponent } from '@app/ui/search-toggle/search-toggle.component';
import { ReportTypeDialogComponent } from '@app/ui/shared/report-type-dialog.component';
import { ReportsModule } from '@app/reports/reports.module';
import { SettingDialogComponent } from '@app/ui/shared/setting-dialog.component';
import { SharedModule } from '@app/shared/shared.module';
import { ToolbarComponent } from '@app/ui/toolbar/toolbar.component';

@NgModule({
  declarations: [
    OptionMultiSelectComponent,
    ExpandablePanelComponent,
    ReportTypeDialogComponent,
    FormLinkComponent,
    SettingDialogComponent,
    AgGridCellOrderNumComponent,
    AgGridCellPlantComponent,
    AgGridCellEditComponent,
    AgGridCellSymbolComponent,
    AgGridNumericEditorComponent,
    ToolbarComponent,
    AutocompleteChiplistComponent,
    SearchToggleComponent
  ],
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    FontAwesomeModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatOptionModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatToolbarModule,
    ReportsModule,
    SharedModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ],
  exports: [
    AgGridNumericEditorComponent,
    ExpandablePanelComponent,
    FormLinkComponent,
    ToolbarComponent,
    OptionMultiSelectComponent,
    AutocompleteChiplistComponent,
    SearchToggleComponent
  ]
})
export class UIModule {}
